export default __webpack_public_path__ + "static/media/mad-ape-001.4a208b0f.svg";